module.exports = __webpack_public_path__ + "static/media/sprites.af50fe4d.png";